export const DM_SANS_FONT_FAMILY = 'DM Sans' as const;

export const LEGACY_POPPINS_FONT_FAMILY = 'Poppins' as const;

export function dmSansFontFaceCheck({
  fontSizePx = 16,
}: { fontSizePx?: number } = {}): string {
  return `${fontSizePx}px "${DM_SANS_FONT_FAMILY}"`;
}

function getPrimaryFontFamilyName(fontFamily: string): string {
  const [firstFamily = ''] = fontFamily.split(',');
  return firstFamily.trim().replace(/^['"]+|['"]+$/g, '');
}

export function isLegacyPoppinsFontFamily(fontFamily: string): boolean {
  const primaryFontFamily = getPrimaryFontFamilyName(fontFamily.trim());
  return (
    primaryFontFamily.toLowerCase() === LEGACY_POPPINS_FONT_FAMILY.toLowerCase()
  );
}
